module.exports = __webpack_public_path__ + "img/1515106736-1024x512.351086c5.png";